<template>
  <div
    v-if="Array.isArray(statisticsData)"
    class="d-flex justify-content-end change-chart"
  >
    <img
      @click="showBar = true"
      class="me-2"
      :src="
        require(`@/assets/icons/bar-chart-${showBar ? 'blue' : 'gray'}.svg`)
      "
    />
    <img
      @click="showBar = false"
      :src="
        require(`@/assets/icons/circle-chart-${showBar ? 'gray' : 'blue'}.svg`)
      "
    />
  </div>
  <div v-if="Array.isArray(statisticsData)">
    <CChart
      v-if="showBar"
      type="bar"
      :data="barAndCircleData"
      :options="{
        plugins: {
          legend: {
            display: false,
          },
        },
      }"
    />
    <CChart v-if="!showBar" type="doughnut" :data="barAndCircleData" />
  </div>
  <div v-else>
    <CChart
      type="scatter"
      :options="{
        plugins: {
          legend: {
            display: false,
          },
        },
        scales: {
          y: {
            ticks: {
              callback: function (value, index, ticks) {
                return value + ' 次'
              },
            },
          },
        },
      }"
      :wrapper="false"
      :data="lineData"
    />
  </div>
</template>
<script>
import { CChart } from '@coreui/vue-chartjs'
import { ref } from '@vue/reactivity'
import { computed } from '@vue/runtime-core'

export default {
  props: {
    statisticsData: {
      type: [Object, Array],
      default: () => [{}],
    },
    questionType: {
      type: String,
      default: '',
    },
  },
  components: {
    CChart,
  },
  setup(props) {
    const showBar = ref(true)
    const getTitleList = computed(() => {
      const titleList = Array.isArray(props.statisticsData)
        ? props.statisticsData.map((e) => {
            return e.title || e.star
          })
        : {}
      return titleList
    })
    const getCount = computed(() => {
      const countList = Array.isArray(props.statisticsData)
        ? props.statisticsData.map((e) => {
            return e.count
          })
        : {}
      return countList
    })
    const barAndCircleData = ref({
      labels: getTitleList.value,
      datasets: [
        {
          indexAxis: 'y',
          data: getCount.value,
          fill: false,
          backgroundColor: [
            'rgb(255, 99, 132)',
            'rgb(255, 159, 64)',
            'rgb(255, 205, 86)',
            'rgb(75, 192, 192)',
            'rgb(54, 162, 235)',
            'rgb(153, 102, 255)',
            'rgb(201, 203, 207)',
          ],

          borderWidth: 1,
        },
      ],
    })

    const lineData = ref({
      datasets: [
        {
          borderColor: 'rgba(23, 123, 175, 1)',
          pointBackgroundColor: 'rgba(23, 123, 175, 1)',
          pointBorderColor: 'rgba(23, 123, 175, 1)',
          borderWidth: 6,
          data: props.statisticsData.all,
        },
      ],
    })
    return {
      lineData,
      barAndCircleData,
      getTitleList,
      getCount,
      showBar,
    }
  },
}
</script>
<style lang="scss" scoped>
.change-chart {
  img {
    width: 20px;
  }
}
</style>
